export default "__VITE_ASSET__C48aPpdy__"